export const BASE_URL = process.env.REACT_APP_API_URL;
export const BASE_URL_WITHOUT_API = process.env.REACT_APP_URL;
export const DATE = '2022-07-30';
